import {memo} from 'react'
import {useTranslation} from 'react-i18next'
import {Selection} from '../../../../components/Selection'
import {TextInputV2} from '../../../../components/TextInputV2'
import {usePaymentTypes} from '../../../../hooks/usePaymentTypes'
import {useProductType} from '../../../../hooks/useProductType'
import {useSalesOrganization} from '../../../../hooks/useSalesOrganization'
import {useAppDispatch, useAppSelector} from '../../../../redux/hooks'
import {filterSelector, setFilterSOLevel} from '../../../../redux/slices/filterSlices'
import {SECTOR_OPTIONS} from '../../../../constants'
import {TRowFilter} from '../../../../components/Table/Table'

export const RowFilter = memo(() => {
  const dispatch = useAppDispatch()
  const {t} = useTranslation()
  const {filterSOLevel: filter} = useAppSelector(filterSelector)
  const {salesOrgOptions} = useSalesOrganization()
  const {options: paymentTypesOptions} = usePaymentTypes()
  const {productTypesOptions} = useProductType()

  const handleFilterChange = (value: Partial<typeof filter>) => {
    dispatch(setFilterSOLevel({...filter, ...value}))
  }

  return (
    <TRowFilter>
      <td>
        <TextInputV2 placeholder={t('ID')} />
      </td>
      <td>
        <TextInputV2
          placeholder={t('Level')}
          value={filter?.level ?? ''}
          onChange={({target}) => handleFilterChange({level: target.value})}
        />
      </td>
      <td>
        <Selection
          data={salesOrgOptions}
          placeholder={t('Sales Org')}
          value={filter?.sales_org_code ?? ''}
          onChange={(sales_org_code) => handleFilterChange({sales_org_code})}
        />
      </td>
      <td>
        <Selection
          data={SECTOR_OPTIONS}
          placeholder={t('Sektor')}
          value={filter?.sector_id ?? ''}
          onChange={(sector_id) => handleFilterChange({sector_id})}
        />
      </td>
      <td>
        <Selection
          data={paymentTypesOptions}
          placeholder={t('Payment Type')}
          value={filter?.payment_type ?? ''}
          onChange={(payment_type) => handleFilterChange({payment_type})}
        />
      </td>
      <td>
        <Selection
          data={productTypesOptions}
          placeholder={t('Product Type')}
          value={filter?.product_type ?? ''}
          onChange={(product_type) => handleFilterChange({product_type})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('Minimum Quantity')}
          value={filter?.min_quantity ?? ''}
          onChange={({target}) => handleFilterChange({min_quantity: target.value})}
        />
      </td>
      <td>
        <TextInputV2
          placeholder={t('Maximum Quantity')}
          value={filter?.max_quantity ?? ''}
          onChange={({target}) => handleFilterChange({max_quantity: target.value})}
        />
      </td>
    </TRowFilter>
  )
})
